import rechargeIconHeader from '@/assets/images/recharge_icon_header.png';
import xIcon from '@/assets/images/x_icon.png';
import AppService from '@/services/AppService';
import DividerLine from '@/components/Common/DividerLine';

export default {
  name: 'TheHeader',
  data() {
    return {
      icon: rechargeIconHeader,
      x_icon: xIcon,
    };
  },
  components: {
    DividerLine,
  },
  methods: {
    closeApp() {
      AppService.closeApp();
    },
  },
};
